import { render, staticRenderFns } from "./more.vue?vue&type=template&id=64ac55d7&scoped=true&"
import script from "./more.vue?vue&type=script&lang=js&"
export * from "./more.vue?vue&type=script&lang=js&"
import style0 from "./more.vue?vue&type=style&index=0&id=64ac55d7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ac55d7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64ac55d7')) {
      api.createRecord('64ac55d7', component.options)
    } else {
      api.reload('64ac55d7', component.options)
    }
    module.hot.accept("./more.vue?vue&type=template&id=64ac55d7&scoped=true&", function () {
      api.rerender('64ac55d7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/UI/CaseOpening/more.vue"
export default component.exports